import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
// import { IHttpErrorPayload, HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
// import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { IOtpPageModel, IOtpPageResponseModel } from '../models/otp-page.model';
import { PreLoginService } from '../../pre-login.service';
import { environment } from 'src/environments/environment';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  IHttpSuccessPayload,
  IHttpErrorPayload
} from '@fpx/core';

@Injectable({
  providedIn: 'root'
})
export class OtpPageService {

  constructor(private httpProvider: HttpProviderService,
    private _preLoginService: PreLoginService) { }


  doResendOtp(payload: IOtpPageModel): Observable<IOtpPageResponseModel> {


    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.commonPublisher);
    httpRequest.setMethod('POST');
    httpRequest.setResource('/preloginresendotp');
    if(payload?.serviceName){
      httpRequest.addHeaderParamter('serviceName',payload?.serviceName);
      delete payload?.serviceName;
    }
    httpRequest.setBody(payload);
    return this.httpProvider.invokeRestApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
      const otpPageResponse: IOtpPageResponseModel = {
        // httpStatus : response.httpStatus,
        // inventoryNo : response.body.chequebookrequest.inventoryNumber
      }
      return response
    },
      catchError((err: IHttpErrorPayload) => {
        return throwError(err)
      })));


    // const payloadData = payload;
    // const httpRequest: HttpRequestPayload = {
    //   resource: `/${apiKey}`,
    //   method: "POST",
    //   body: payloadData
    // }
    // return this.httpProvider.invokeApi(httpRequest).pipe(map((response: IHttpSuccessPayload<any>) => {
    //   const otpPageResponse: IOtpPageResponseModel = {
    //     // httpStatus : response.httpStatus,
    //     // inventoryNo : response.body.chequebookrequest.inventoryNumber
    //   }
    //   return response
    // },
    //   catchError((err: IHttpErrorPayload) => {
    //     return throwError(err)
    //   })));
  }


  doSubmit(apiKey, payload: IOtpPageModel): Observable<IOtpPageResponseModel> {

    
    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.commonPublisher);
    httpRequest.setMethod('POST');
    // httpRequest.httpPayload.headerParams = [{key:"serviceName",value:"NEWDEVICELOGIN"}]
    // httpRequest.addHeaderParamter('serviceName','NEWDEVICELOGIN');
    httpRequest.setResource(`/${apiKey}`);
    if(payload?.otpverify?.serviceName){
      httpRequest.addHeaderParamter('serviceName',payload?.otpverify?.serviceName);
      delete payload?.otpverify?.serviceName;
    }
    httpRequest.setBody(payload);
    return this.httpProvider.invokeRestApi(httpRequest)
    .pipe(map((response: IHttpSuccessPayload<any>) => {
      if(response.body && response.body){
        this._preLoginService.setToken(response.body);
      } 
      return response
    },
    catchError((err: IHttpErrorPayload) => {
      return throwError(err)
    })));



  }


  submitChannel(payload){
    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.commonPublisher);
    httpRequest.setMethod('POST');
    httpRequest.setResource(`/createotp`);
    httpRequest.setBody({"createotp":payload});

    return this.httpProvider.invokeRestApi(httpRequest)
    .pipe(map((response: IHttpSuccessPayload<any>) => { 
      return response;
    },
    catchError((err: IHttpErrorPayload) => {
      return throwError(err);
    })));
  }

  fetchOpenNewAccount(refNo): Observable<any> {
    const request: any = {
      resource: `/opennewaccount/${refNo}`,
      method: 'GET',
    };

    return this.httpProvider.invokeApi(request).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body.opennewaccount;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
